export class MapWidgetLogic {
  /**
   * Mostra o nasconde il controllo di ricerca per particelle catastali e il collapse per l'intersezione.
   */
  static showCadastralParticelsAndIntersections(): boolean {
    return process.env.ENABLE_CADASTRAL_PARTICLES === 'true';
  }
}
